import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import WveStyleElementLabel from 'Components/WveSettingsPanel/WveStyleElement/WveStyleElementLabel/WveStyleElementLabel';
import { shouldSetArtboard } from 'PreviewActions';
import { getSelectedAdstate, getAdStates, getFilteredAdSates } from 'Selectors';
import { DEVICE } from 'PreviewConstants/';
import { UI } from 'SharedConstants/';
import Select from 'SharedComponents/WveInputs/style';

const Row = styled.div`
  display: flex;
  align-items: center;
  border: none;
  padding: 15px 0 0 10px;
`;

const WveSelect = styled(Select)`
  margin-right: auto;
  width: 70%;
  max-width: none;
`;

class ArtboardSelector extends Component {
  handleChange = (event) => {
    const { options, shouldSetArtboard } = this.props; // eslint-disable-line no-shadow
    const artboard = event.value;
    const {
      artboards,
    } = store.getState();
    const selectedArtboard = artboards.filter(a => a.name === artboard)[0];
    window['wve-api'].shouldSetArtboard(selectedArtboard);
  };

  render() {
    const { artboardName, options, deviceIsSelected } = this.props;
    const { handleChange } = this;

    const availableArtboards = options.map(option => ({ label: option, value: option }));

    return (<Row>
      <WveStyleElementLabel label="artboard" />
      <WveSelect
        value={artboardName}
        options={availableArtboards}
        searchable
        clearable={false}
        onChange={handleChange}
        disabled={deviceIsSelected}
      />
    </Row>);
  }
}

ArtboardSelector.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string),
  artboardName: PropTypes.string,
  shouldSetArtboard: PropTypes.func,
  deviceIsSelected: PropTypes.bool.isRequired,
};

ArtboardSelector.defaultProps = {
  options: [],
  artboardName: '',
  viewports: [],
  shouldSetArtboard: () => {},
};

const mapStateToProps = (state) => {
  const artboards = getFilteredAdSates(state);
  const selectedArtboard = getSelectedAdstate(state);
  return {
    artboardName: selectedArtboard.name,
    options: artboards.map(artboard => artboard.name).toIndexedSeq().toArray(),
    viewports: artboards.map(artboard => artboard.viewport).toIndexedSeq().toArray(),
    deviceIsSelected: state.getIn([UI, DEVICE]) !== null,
  };
};

const mapDispatchToProps = dispatch => ({
  shouldSetArtboard: artboard =>
    dispatch(shouldSetArtboard(artboard)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ArtboardSelector);



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/components/SideBar/ArtboardSelector/ArtboardSelector.jsx